import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from "./Tooltip";
import uuid from "react-native-uuid";

LabelInfoTooltip.defaultProps = {
  tooltipClassName: '',
};

LabelInfoTooltip.propTypes = {
  msg: PropTypes.string.isRequired,
  tooltipClassName: PropTypes.string,
};

function LabelInfoTooltip(props) {
  const [idTooltip, setIdTooltip] = React.useState('x' + uuid.v4());

  return (
    <React.Fragment>
      <i id={idTooltip} className="fas fa-info-circle cursor-pointer" />
      <Tooltip className={`tooltip-on-modal ${props.tooltipClassName}`} id={idTooltip} msg={props.msg} />
    </React.Fragment>
  );
}

export default LabelInfoTooltip;
